module.exports = __webpack_public_path__ + "img/会员权益概览-立即订餐.e39d8d80.jpg";